import axios from 'axios';
import store from '../store';

let baseURL = 'http://localhost:3000';

if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://lea.services/api';
}

const http = axios.create({
    baseURL: baseURL
});

http.interceptors.request.use(
    function(config) {
        store.dispatch('user/loadingstart');
        return config;
    }, function(error) {
    // Do something with request error
        return Promise.reject(error);
    });

http.interceptors.response.use(

    function(response) {
        store.dispatch('user/loadingstop');
        return response;
    },
    function(error) {
        store.dispatch('user/loadingcancle');

        if (error.response.status === 499) {
            localStorage.removeItem('JWT');
            location.reload();
        } else if (error.response) {
            store.dispatch('notifications/notification', {
                msg: error.response.data,
                error: true,
                time: 2000
            }, { root: true });
        } else { // else show the plain error message
            store.dispatch('notifications/notification', {
                msg: error.message,
                error: true,
                time: 2000
            }, { root: true });
        }
    }

);

export default http;
